import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { matchCompanySso } from 'containers/LoginPage/utils';
import { showErrorAction } from 'containers/Notification/actions';
import OrganizationApi from 'entities/organization/api';
import Organization from 'entities/organization/model';
import { useQuery } from 'entities/useQuery';

/**
 * Resolve user's SSO company based on email or companyId
 */
export const useSsoCompany = (email: string, companyId?: string): Organization | null => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { data: ssoCompanies, loading } = useQuery<Organization[]>(
    () => OrganizationApi.fetchSsoCompanies().toPromise() as Promise<Organization[]>,
    [],
    undefined,
    undefined,
    () => {
      dispatch(
        showErrorAction('An error occured during loading, please reload the page to login with SSO')
      );
    }
  );

  const company =
    (!!(email || companyId) &&
      !!ssoCompanies.length &&
      (companyId
        ? ssoCompanies.find((ssoCompany) => ssoCompany.id === companyId)
        : matchCompanySso(email, ssoCompanies))) ||
    null;

  useEffect(() => {
    if (companyId && !company && !loading) {
      console.warn(`Invalid companyId ${companyId}`);
      history.replace('/login');
    }
  }, [companyId, company, loading, history]);

  // @NOTE-EV: add exception for internal users using deed emails customized with +
  const isDeedNonSsoEmail =
    email && ssoCompanies && email?.endsWith('@joindeed.com') && email?.includes('+');

  if (
    company &&
    !isDeedNonSsoEmail &&
    (company.sso2?.organizerSsoEnabled || company.sso2?.adminSsoEnabled)
  ) {
    return company;
  }
  return null;
};
